import moment from "moment";

export const utcToLocalDateFormat = (date) => {
    const formatDate = moment.utc(date).local().format("YYYY/MM/DD hh:mm A");
    return formatDate;
}